import loadable from "utils/loadable";

export const HalamanMonitoringMember = loadable(() => import("./index"));
export const PopupData = loadable(() => import("./PopupData"));
